import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TicketService } from 'src/app/private/services/tickets.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-bulk-ticket',
  imports: [SharedModule],
  templateUrl: './delete-bulk-ticket.component.html',
  styleUrl: './delete-bulk-ticket.component.scss'
})
export class DeleteBulkTicketComponent {

  @Input() selectedTickets: any[] = [];
  @Output() closeDialog = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  isLoading = false;

  constructor(
    private ticketService: TicketService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleDelete() {


    this.isLoading = true;

    const payload = {
      // id: [this.ticketData.id],
      id: this.selectedTickets.map(ticket => ticket.id),
      organization_id: this.localStorage.getOrganizationId()
    };

    this.ticketService.deleteTicket(payload).subscribe({
      next: () => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Deleted',
          detail: 'Ticket deleted successfully.'
        });
        this.reload.emit();
        this.closeDialog.emit();
      },
      error: () => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete ticket.'
        });
      }
    });
  }

}
